/**
 * Logger sécurisé (version simplifiée pour le widget)
 */
export const logger = {
  info: function (message, context) {
    if (
      window.RingadoChatWidget?.instance?.config?.debug ||
      window.RingadoConfig?.debug
    ) {
      console.log(`ℹ️ [Ringado Widget] ${message}`, context || '');
    }
  },
  warn: function (message, context) {
    if (
      window.RingadoChatWidget?.instance?.config?.debug ||
      window.RingadoConfig?.debug
    ) {
      console.warn(`⚠️ [Ringado Widget] ${message}`, context || '');
    }
  },
  error: function (message, error) {
    console.error(`❌ [Ringado Widget] ${message}`, error || '');
  },
};
